module.exports = __webpack_public_path__ + "assets/img/role-e18372b9.png";